import { render, staticRenderFns } from "./DetailPelunasan.vue?vue&type=template&id=0f61dc32&"
import script from "./DetailPelunasan.vue?vue&type=script&lang=js&"
export * from "./DetailPelunasan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports